import NumberFormat from "react-number-format";

const FormattedAmount = ({
	value: rawValue,
	className,
	fixedDecimalScale = false,
	displayType = "text",
	currency = "$",
}) => {
	const value = typeof rawValue === "string" ? parseFloat(rawValue) : rawValue;

	if (!Number.isFinite(value)) {
		return null;
	}

	return (
		<NumberFormat
			value={value}
			displayType={displayType}
			thousandSeparator={true}
			prefix={currency}
			className={className}
			decimalScale={2}
			fixedDecimalScale={fixedDecimalScale}
		/>
	);
};

export default FormattedAmount;
